import React, {useContext} from 'react'
import {
  Popover,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  CircularProgress,
} from '@material-ui/core/'
import PopupMoreButtons from './BarcodeLibraryPopupMoreButtons'
import {MoreVert} from '@material-ui/icons'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import VisibleIcon from '@material-ui/icons/Visibility'
import {Mutation} from 'react-apollo'
import {deleteDataRecord} from '../../graphql/barcode/mutations/deleteRecordMutation'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import EditDrawer from '../BarcodeLibraryEditDrawer'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryTableActions.styles'
import {UserContext} from '../../context/UserContext'
import {ToastMessageContext} from '../../context/ToastMessage'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeLibraryTableActions(props) {
  const {t} = useTranslation()
  const classes = useStyles()
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const [deleteTitle, setDeleteTitle] = React.useState(
    t('barcode.library.table-actions.delete-sure')
  )
  const [deleteBody, setDeleteBody] = React.useState(
    t('barcode.library.table-actions.delete-permanent')
  )
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const [canDelete, setCanDelete] = React.useState(true)
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined
  const [deleting, setDeleting] = React.useState(false)
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const userId = parseInt(window.localStorage.getItem('user_id'))

  function getDataRelationship(record) {
    let settingName = ''
    record.map(data => {
      settingName = settingName + data.name + '\n'
      return settingName
    })
    setDeleteBody(settingName)
  }

  function showMoreOptions(event) {
    const {showTable, record} = props
    setAnchorEl(null)
    setDeleteTitle(t('barcode.library.table-actions.delete-sure'))
    setDeleteBody(t('barcode.library.table-actions.delete-permanent'))
    if (showTable === 'automated' || showTable === 'fieldValue') {
      setAnchorEl(event.currentTarget)
    } else if (showTable === 'sheets' && !record.accountId) {
      setDrawerOpen(true)
    } else {
      if (showTable === 'labels' && record.barcodeSettings.length > 0) {
        setDeleteTitle(t('barcode.library.table-actions.cannot-delete-barcode'))
        getDataRelationship(record.barcodeSettings)
      } else if (showTable === 'sheets' && record.labels.length > 0) {
        setDeleteTitle(t('barcode.library.table-actions.cannot-delete-label'))
        getDataRelationship(record.labels)
      } else {
        setCanDelete(false)
      }
      setDeleteDialog(true)
    }
  }

  function handleClose() {
    setAnchorEl(null)
    setDeleteDialog(false)
  }

  function deleteDataClick(event, deleteData) {
    if (!validateBarcodePermission(currentUser, 'can_delete')) {
      return
    }
    const {showTable, record} = props
    deleteData({
      variables: {
        id: record.id,
        table: showTable,
      },
    })
    setDeleting(true)
  }

  function mutationLoad() {
    setDeleteDialog(false)
    setDeleting(false)
    toast.popMessage(t('barcode.library.table-actions.success-delete'), 'success')
  }

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setDrawerOpen(open)
  }

  function optionButtonIcon(showTable, record) {
    if (showTable === 'labels' || (showTable === 'sheets' && record.accountId)) {
      return <DeleteIcon hidden={!validateBarcodePermission(currentUser, 'can_delete')} />
    } else if (showTable === 'sheets' && !record.accountId) {
      return <VisibleIcon />
    } else {
      return <MoreVert />
    }
  }

  function editButton(props) {
    const {showTable, record, tableView} = props
    if (showTable === 'sheets' && !record.accountId) {
      return (
        <Box fontSize={15} color="#D3D3D3" hidden={tableView === 'gridview'}>
          {t('barcode.library.table-actions.template-lock')}
        </Box>
      )
    } else {
      return <EditIcon />
    }
  }

  return (
    <div>
      {props.showTable !== 'labels' && validateBarcodePermission(currentUser, 'can_edit') && (
        <IconButton
          disabled={props.showTable === 'sheets' && !props.record.accountId}
          onClick={toggleDrawer(true)}
          size="small"
        >
          {editButton(props)}
        </IconButton>
      )}

      {props.showTable === 'labels' && validateBarcodePermission(currentUser, 'can_edit') && (
        <IconButton
          size="small"
          to={'edit-label/' + props.record.id}
          component={Link}
          labelValue={props.record}
        >
          {editButton(props)}
        </IconButton>
      )}

      <IconButton onClick={showMoreOptions} size="small">
        {optionButtonIcon(props.showTable, props.record)}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PopupMoreButtons
          showTable={props.showTable}
          record={props.record}
          poppOverClose={setAnchorEl}
          accountId={props.accountId}
        />
      </Popover>

      {deleteDialog && (
        <div class="ds-modal-wrapper">
          <div class="ds-backdrop"></div>
          <div class="ds-modal-simple ds-modal--destructive">
            {deleteDialog &&
              window !== window.parent &&
              window.parent.postMessage(
                'deleteDialogBox',
                process.env.REACT_APP_BARCODE_WINDOW_URL
              )}
            <div class="ds-modal-header">
              <h4 class="mdl-title ds-t400r ds-tg700" style={{textAlign: 'left'}}>
                {deleteTitle}
              </h4>
            </div>
            <div class="ds-modal-body ds-tg600 ds-t100r" style={{textAlign: 'left'}}>
              {deleteBody}
            </div>
            <div class="ds-modal-footer">
              <Mutation
                mutation={deleteDataRecord}
                refetchQueries={() => [
                  {
                    query: libraryPageQuery,
                    variables: {
                      accountId: parseInt(props.accountId),
                      token: accessToken,
                      userId: userId,
                      filter: '',
                    },
                  },
                ]}
                awaitRefetchQueries
                onCompleted={() => mutationLoad()}
              >
                {(deleteDataRecord, {data}) => (
                  <button
                    class="mdl-affirmative ds-btn-destructive mr-8"
                    onClick={e => deleteDataClick(e, deleteDataRecord)}
                    autoFocus
                    hidden={!validateBarcodePermission(currentUser, 'can_delete')}
                  >
                    {deleting ? (
                      <>
                        {t('barcode.library.table-actions.deleting')}
                        <CircularProgress size={20} />
                      </>
                    ) : (
                      t('barcode.library.table-actions.yes-delete')
                    )}
                  </button>
                )}
              </Mutation>
              <button
                class="mdl-negative ds-btn-secondary"
                onClick={handleClose}
                disabled={deleting}
              >
                {t('barcode.library.table-actions.nevermind')}
              </button>
            </div>
          </div>
        </div>
      )}

      <Drawer anchor="right" open={drawerOpen}>
        <EditDrawer
          record={props.record}
          showTable={props.showTable}
          toggleDrawer={toggleDrawer()}
          labelsRecord={props.labelsRecord}
        />
      </Drawer>
    </div>
  )
}
